import $ from 'jquery';
import Swiper from 'swiper';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';

import '../css/about/video-block.css';
import '../css/about/award-block.css';
import '../css/contact-block.css';
import '../css/about/youtube-video.css';
import '../css/modal-block.css';
import '../css/card-block.css';

import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';

import '../css/about/intro-block.css';
import '../css/about/story-block.css';
import '../css/about/article-block.css';
import '../css/about/swiper-info.css';
import '../css/success-alert.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { uploadUri } from './appConfig';
import scrollBackground from '../js/about/scrollBackground';
import articlePosition from '../js/about/articlePosition';
import toggleModal from '../js/toggleModal';
import getWordingJson from './request/wordingJson';
import getGuestList from './request/guestList';
import getMediaList from './request/mediaList';
import getVideoList from './request/videoList';
import wordingSetter from './wordingSetter';
import wrapSwiperSlide from './about/wrapSwiperSlide';
import generateVideoBlock from './about/generateVideoBlock';
import generatePhotoCard from './about/generatePhotoCard';
import generateLinkCard from './about/generateLinkCard';
import urlParser from './urlParser';
import hideLoadingImage from './common/hideLoadingImage';

setup();

/**
 * only visible in the tablet, mobile
 */
if (window.innerWidth < 992) {
	Swiper('.swiper-container.-story', {
		effect: 'fade',
		speed: 500,
		pagination: '.swiper-pagination',
		direction: 'vertical',
		slidesPerView: 1,
		paginationClickable: true,
		spaceBetween: 30,
		mousewheelControl: true,
		touchReleaseOnEdges: true,
	});
}

let slideNumber = 2;
if (window.innerWidth >= 1160) {
	slideNumber = 3;
} else if (window.innerWidth < 768) {
	slideNumber = 1;
}

const swiperConfig = {
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
	slidesPerView: slideNumber,
	centeredSlides: false,
	paginationClickable: true,
	spaceBetween: 30,
	loop: true,
};

const articlePositionArray = articlePosition();
window.addEventListener('scroll', (e) => scrollBackground(e, articlePositionArray));

$('.section-block.-video').on('click', '.modal-marker', (e) => toggleModal(e.target));

const wordingJsonPromise = getWordingJson('about')
	.then((json) => wordingSetter(json));

const guestListPromise = getGuestList()
	.then((json) => {
		json.guests.forEach((item) => {
			document.querySelector('.swiper-container.-guest > .swiper-wrapper').appendChild(
				wrapSwiperSlide(
					generatePhotoCard(
						item.title,
						item.date.substr(0, 7).replace('-', '.'),
						`${uploadUri}/${item.thumb}`,
					),
				),
			);
		});

		Swiper('.swiper-container.-guest', swiperConfig);
	});

const videoListPromise = getVideoList(0, window.innerWidth < 768 ? 3 : 4)
	.then((json) => {
		json.videos.forEach((item) => {
			document.querySelector('.section-block.-video > .content').appendChild(
				generateVideoBlock(item),
			);
		});
	});

/**
 * make sure each promise is finished
 */
const promiseArray = [wordingJsonPromise, guestListPromise, videoListPromise];

if (urlParser.language !== 'en') {
	const mediaListPromise = getMediaList()
		.then((json) => {
			json.reports.forEach((item) => {
				document.querySelector('.swiper-container.-media > .swiper-wrapper').appendChild(
					wrapSwiperSlide(
						generateLinkCard(
							item.id,
							item.title,
							item.date.substr(0, 7).replace('-', '.'),
							`${uploadUri}/${item.thumb}`,
						),
					),
				);
			});

			Swiper('.swiper-container.-media', swiperConfig);
		});

	promiseArray.push(mediaListPromise);
}

Promise.all(promiseArray)
	.then(() => hideLoadingImage());



// WEBPACK FOOTER //
// ./src/js/about.js